import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import UISideNav from 'UIComponents/nav/UISideNav';
import { Component } from 'react';
import { cloneDefaultProps, clonePropTypes } from './internal/utils';

/**
 * A [`UISideNav`](https://private.hubteamqa.com/uicomponents-storybook/?path=/docs/uicomponents-nav-uisidenav--basic)
 * type component with router support.
 */
import { jsx as _jsx } from "react/jsx-runtime";
class UIRouterSideNav extends Component {
  render() {
    const _this$props = this.props,
      rest = Object.assign({}, (_objectDestructuringEmpty(_this$props), _this$props));
    return /*#__PURE__*/_jsx(UISideNav, Object.assign({}, rest));
  }
}
UIRouterSideNav.displayName = 'UIRouterSideNav';
UIRouterSideNav.propTypes = Object.assign({}, clonePropTypes(UISideNav));
UIRouterSideNav.defaultProps = Object.assign({}, cloneDefaultProps(UISideNav));
export default UIRouterSideNav;